import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import MatchDetails from '../components/dashboard/MatchMonitoring/MatchDetails';
import * as dashboardActions from '../redux/actions/dashboardActions';

const MatchDetailPageContainer = ({ 
  dashboard, 
  actions,
  userId
}) => {
  const { matchId } = useParams();
  const history = useHistory();
  
  // Fetch match details
  useEffect(() => {
    if (matchId && userId) {
      actions.fetchMatchDetails({ matchId, userId });
    }
  }, [matchId, userId, actions]);
  
  const handleBack = () => {
    history.push('/dashboard');
  };
  
  const handleExport = async (matchId) => {
    try {
      await actions.exportMatchDebugData({ matchId, userId });
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export debug data. Check console for details.');
    }
  };
  
  return (
    <MatchDetails
      matchId={matchId}
      matchData={dashboard.selectedMatch}
      loading={!dashboard.selectedMatch}
      onBack={handleBack}
      onExport={handleExport}
    />
  );
};

const mapStateToProps = (state) => ({
  dashboard: state.dashboard,
  userId: state.catalogReducer?.user?.userId
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(dashboardActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MatchDetailPageContainer);

